<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 pb-52 pt-6">
    <Form class="space-y-4 text-gray-700">

      <div class="container mx-auto px-4 max-w-5xl">
        <h1 class="font-bold text-gray-800 mb-0 text-2xl text-center pt-5">
          ESTADO DEL PAGO
        </h1>

        <!-- Formulario -->
        <div class="w-full mt-10">
          <div class="flex flex-col items-center text-center rounded-lg shadow-lg mt-4 bg-gray-200 p-10">
            <h2>
              {{ errorMessage }}
            </h2>
          </div>
        </div>

        <div class="h-8">
        </div>

      </div>

    </Form>

  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Form } from 'vee-validate';
import Swal from 'sweetalert2'

import suiteService, { Acreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { useRoute } from 'vue-router'
import HeaderSection from '@/components/HeaderSection.vue'
import { VERIFICADO, UPDATE } from 'qreventos-suite/constantes';


export default defineComponent({
  components: {
    Form, HeaderSection
  },
  data() {
    return {
      errorMessage: '',
      verificationCode: '',
      oc: '',
      ok: '',
      acreditado: undefined as unknown as Acreditado,
    };
  },
  methods: {
    cancelarAcreditacion() {
      this.$router.go(0);
    },
  },


  async mounted() {
    console.log("mounted");
    const route = useRoute();
    const hash = `${route.query.hash}`

    this.ok = `${route.query.ok}`
    this.errorMessage = `${route.query.errorMessage}`;
    this.verificationCode = `${route.query.verificationCode}`;
    this.oc = `${route.query.oc}`;

    this.acreditado = await suiteService.findAcreditadoByHash(suiteConfig.evento, hash) as Acreditado;
    if (!this.acreditado) {
      Swal.fire({
        title: "¡Atención!",
        html: "El acreditado no existe o no se encuentra registrado.",
        icon: "error",
      }).then(() => {
        window.location.href = "https://acreditaciones.qreventos.com/forovacamuerta";
      });
      return;
    }

    if (this.ok != "1") {
      this.errorMessage = "Hubo un error confirmando el pago : " + this.errorMessage;
    } else {
      this.acreditado.modificado = UPDATE;
      this.acreditado.estadoAcreditado.id = VERIFICADO;
      this.acreditado.notificar = true;
      await suiteService.saveOrUpdate(suiteConfig.evento, this.acreditado);
      this.errorMessage = "Su pago fue registrado correctamente.";
    }


  }
});
</script>